export default async function handleLeadNewFilterChanges(eventValue, leadsAwaitingAction, investigatingLeads, closingLeads, leadTierFilter, leadTagFilter, leadTypeFilter) {
    let awaitingAction = await handleFiltering(eventValue, leadsAwaitingAction, leadTierFilter, leadTagFilter, leadTypeFilter);
    let investigating = await handleFiltering(eventValue, investigatingLeads, leadTierFilter, leadTagFilter, leadTypeFilter);
    let closing = await handleFiltering(eventValue, closingLeads, leadTierFilter, leadTagFilter, leadTypeFilter);
    return {awaitingAction, investigating, closing}
  }

  let handleFiltering = async (eventValue, leads, leadTierFilter, leadTagFilter, leadTypeFilter) => {
    let filteredLeads = []
    let filterNew = true
    if (eventValue === 'false') {
      filterNew = false
    } 
    for (let i = 0; i < leads.length; i++) {
      let pushLead = true
      if (filterNew) {
        if (!leads[i].newLeadLabel) {
          pushLead = false
        }
      }
      if (pushLead) {
        if (leadTierFilter !== 'All') {
          if (leadTierFilter === 'Tier 1') {
            if (leads[i].tier !== 1) {
              pushLead = false
            }
          } else if (leadTierFilter === 'Tier 2') {
            if (leads[i].tier !== 2) {
              pushLead = false
            }
          } else {
            if (leads[i].tier !== 0) {
              pushLead = false
            }
          }
        } else if (leadTypeFilter !== 'All') {
          if (leadTypeFilter === 'renegotiation') {
            if (leads[i].targetOutcome !== 'renegotiation') {
              pushLead = false
            }
          } else {
            if (leads[i].targetOutcome !== 'refinance') {
              pushLead = false
            }
          }
        } else if (leadTagFilter[0] !== 'All') {
          for (let j = 0; j < leadTagFilter.length; j++) {
            let matchingInvestigation = leads[i].tagIds.find(tag => tag === leadTagFilter[j])
            if (!matchingInvestigation) {
              pushLead = false
            }
          }
        }      
      }
      if (pushLead) {
        filteredLeads.push(leads[i])
      }
    }
  
    return filteredLeads
  }